import { useEffect } from "react"
import ArrowBackButton from "../../../../components/button/ArrowBackButton"
import { Form } from "react-bootstrap"
import usePhaseDeadline from "./usePhaseDeadline"
import { useParams } from "react-router-dom"
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient"

const PhaseDeadline = () => {
    // const [phasesCount, setPhasesCount] = useState(5)
    // const [phase, setPhase] = useState([{label:"aa",value:"ASD"},{label:"aa",value:"ASD"}])
    const params = useParams()
    const {
        phases,
        postPhase,
        onChangeHandler,
        getCurrentPhase,
        update,
        putPhase,
        isSaving,
        projectName
    } = usePhaseDeadline()

    useEffect(() => {
        if (params.project_id) {
            getCurrentPhase(params.project_id)
            // getAllPhase(params.project_id)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return (
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{ marginBottom: '24px' }}>
                <ArrowBackButton title={update ? "Update Phase Deadline" : "Insert Phase Deadline"} isTwoSection={true}/>
            </div>
            
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <h5 style={{ 
                    margin: 0,
                    marginBottom: '24px',
                    fontWeight: 600,
                    color: '#1a1a1a',
                    fontSize: '18px'
                }}>
                    Phase Configuration
                </h5>

                <form>
                    <div className="mb-4">
                        <div className="mb-4" style={{
                                padding: '20px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                border: '1px solid #e5e7eb'
                        }}>
                            <label htmlFor="ProjectName" style={{ 
                                fontWeight: '600', 
                                color: '#374151', 
                                fontSize: '14px',
                                marginBottom: '8px',
                                display: 'block'
                            }}>
                                Project Name <span style={{color: 'red'}}>*</span>
                            </label>
                            <input 
                                required
                                disabled
                                type="text" 
                                name="name"
                                className="form-control" 
                                id="ProjectName" 
                                value={projectName || ''}
                                style={{
                                    borderRadius: '8px',
                                    border: '1px solid #dee2e6',
                                    padding: '10px 14px',
                                    fontSize: '16px',
                                }}
                            />
                        </div>
                    </div>

                    {
                        Array.isArray(phases) && phases?.map((phase, index) => (
                            <div key={phase.Order} className="mb-4" style={{
                                padding: '20px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '8px',
                                border: '1px solid #e5e7eb'
                            }}>
                                <div className="row" style={{alignItems: 'center'}}>
                                    <div className="col-3">
                                        <label htmlFor="PhaseName" style={{ 
                                            fontWeight: '600', 
                                            color: '#374151', 
                                            fontSize: '14px',
                                            marginBottom: '8px',
                                            display: 'block'
                                        }}>
                                            Phase-{phase.Order} <span style={{color: 'red'}}>*</span>
                                        </label>
                                        <input 
                                            required
                                            disabled
                                            type="text" 
                                            name="Deadline"
                                            className="form-control" 
                                            id="Deadline" 
                                            value={phase.Name || ''}
                                            style={{
                                                borderRadius: '8px',
                                                border: '1px solid #dee2e6',
                                                padding: '10px 14px',
                                                fontSize: '16px',
                                            }}
                                        />
                                    </div>

                                    <div className="col-3">
                                        <label htmlFor="ProjectName" style={{ 
                                            fontWeight: '600', 
                                            color: '#374151', 
                                            fontSize: '14px',
                                            marginBottom: '8px',
                                            display: 'block'
                                        }}>
                                            Start Date <span style={{color: 'red'}}>*</span>
                                        </label>
                                        <input 
                                            required
                                            type="date" 
                                            name="StartDate"
                                            className="form-control" 
                                            id="StartDate" 
                                            value={phase.StartDate || ''}
                                            onChange={(e) => onChangeHandler(e,phase.PhaseID)}
                                            onClick={(e) => {
                                                if (e.target.showPicker) {
                                                    e.target.showPicker();
                                                }
                                            }}
                                            style={{
                                                borderRadius: '8px',
                                                border: '1px solid #dee2e6',
                                                padding: '10px 14px',
                                                fontSize: '16px'
                                            }}
                                        />
                                    </div>

                                    <div className="col-3">
                                        <label htmlFor="ProjectName" style={{ 
                                            fontWeight: '600', 
                                            color: '#374151', 
                                            fontSize: '14px',
                                            marginBottom: '8px',
                                            display: 'block'
                                        }}>
                                            Deadline <span style={{color: 'red'}}>*</span>
                                        </label>
                                        <input 
                                            required
                                            type="date" 
                                            name="EndDate"
                                            className="form-control" 
                                            id="EndDate" 
                                            value={phase.EndDate || ''}
                                            onChange={(e) => onChangeHandler(e,phase.PhaseID)}
                                            onClick={(e) => {
                                                if (e.target.showPicker) {
                                                    e.target.showPicker();
                                                }
                                            }}
                                            style={{
                                                borderRadius: '8px',
                                                border: '1px solid #dee2e6',
                                                padding: '10px 14px',
                                                fontSize: '16px'
                                            }}
                                        />
                                    </div>

                                    <div className="col-3" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                        <Form.Check 
                                            name={'ReviewSPMO'}
                                            type={'checkbox'}
                                            id={`default-checkbox-${index}`}
                                            label={`Review by SPMO`}
                                            checked={phase.ReviewSPMO || false}
                                            onChange={(e) => onChangeHandler(e,phase.PhaseID)}
                                            style={{ fontSize: '14px', color: '#374151' }}
                                        />
                                        
                                        <Form.Check 
                                            name={'Guideline'}
                                            type={'checkbox'}
                                            id={`default-checkbox-2-${index}`}
                                            label={`Follow Guidance`}
                                            checked={phase.Guideline || false}
                                            onChange={(e) => onChangeHandler(e,phase.PhaseID)}
                                            style={{ fontSize: '14px', color: '#374151' }}
                                        />
                                        
                                        <Form.Check 
                                            name={'ShowChart'}
                                            type={'checkbox'}
                                            id={`default-checkbox-3-${index}`}
                                            label={`Show Chart`}
                                            checked={phase.ShowChart || false}
                                            onChange={(e) => onChangeHandler(e,phase.PhaseID)}
                                            style={{ fontSize: '14px', color: '#374151' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))
                    }

                    <div className="d-flex justify-content-end">
                        { update ? 
                            <ActionButtonGradient
                                onClick={async (e) => {
                                    await e.preventDefault();
                                    await putPhase(e);
                                }}
                                disabled={isSaving}
                                variant="primary"
                                children={isSaving ? "Saving..." : "Save Changes"}
                            />
                            :
                            <ActionButtonGradient
                                onClick={async (e) => {
                                    await e.preventDefault();
                                    await postPhase(e);
                                }}
                                disabled={isSaving}
                                variant="success"
                                children={isSaving ? "Saving..." : "Save Phase"}
                            />
                        }
                    </div>
                </form>
            </div>
        </div>
    )
}

export default PhaseDeadline